import { CHAT_WIDGET_COPY, CHATWERK_TRIGGER_SELECTOR } from './chat-widget.constants';
import type { ChatwerkConfig, ChatwerkTheme, ChatwerkThemeKey } from './chatwerk.types';

/** ChatWerk's colours mapped onto the site's tokens (`styles/theme/base.css`). */
const THEME_TOKENS: Record<ChatwerkThemeKey, string> = {
    mainColor: '--accent',
    headerBackgroundColor: '--accent',
    headerFontColor: '--accent-contrast',
    intrudictionFieldBackgroundColor: '--surface',
    intrudictionFieldFontColor: '--text',
    circleIconBackground: '--accent',
    circleIconColor: '--accent-contrast',
    welcomeMessageBackgroundColor: '--surface',
    welcomeMessageTextColor: '--text',
};

/**
 * The chat frame cannot read our custom properties, so their resolved values are
 * handed over. A token that does not resolve is left out and ChatWerk's default
 * applies.
 */
function resolveTheme(): ChatwerkTheme {
    const styles = getComputedStyle(document.documentElement);
    const theme: ChatwerkTheme = {};

    for (const [key, token] of Object.entries(THEME_TOKENS) as [ChatwerkThemeKey, string][]) {
        const value = styles.getPropertyValue(token).trim();
        if (value) theme[key] = value;
    }

    return theme;
}

export function buildChatwerkConfig(organizationId: string): ChatwerkConfig {
    return {
        inboxConfig: {
            organizationQuery: { id: organizationId },
            opened: true,
            language: 'de',
            dictionaries: { de: { welcomeMessage: CHAT_WIDGET_COPY.welcomeMessage } },
            theme: resolveTheme(),
        },
        triggerSelector: CHATWERK_TRIGGER_SELECTOR,
        showNativeTrigger: false,
    };
}
